import React from "react";
import { useTranslation } from "react-i18next";
import Layout from "components/Layout";
import { OnboardingChecklist } from "components/Onboarding";

/**
 * Página dedicada de onboarding ("Primeros pasos").
 *
 * Ruta: /getting-started (solo ADMIN, gestionado en App.js).
 * Tras el login, a los administradores que no han completado el onboarding se
 * les redirige aquí; desde el sidebar pueden volver con el CTA "Continuar".
 */
const GettingStarted = () => {
	const { t } = useTranslation();

	return (
		<Layout className="page-getting-started">
			<div className="heading">
				<div className="heading-left">
					<h1 className="title">{t("dashboard.title")}</h1>
				</div>
			</div>

			<OnboardingChecklist standalone />
		</Layout>
	);
};

export default GettingStarted;
